import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../../services/auth/auth.service";

export const noAuthGuard: CanActivateFn = (_, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (state.url.startsWith("/admin")) {
        return authService.isAdminLoggedIn() ? router.createUrlTree(["/admin/default"]) : true;
    }

    return authService.isUserLoggedIn ? router.createUrlTree(["/home"]) : true;
};
